"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockIcon = void 0;
const react_1 = __importDefault(require("react"));
const IconBase_1 = __importDefault(require("react-icons/IconBase"));
exports.LockIcon = () => (react_1.default.createElement(IconBase_1.default, { viewBox: "0 0 12 12" },
    react_1.default.createElement("path", { d: "M10.125 5.25H9.5625V3.5625C9.5625 1.59844 7.96406 0 6 0C4.03594 0 2.4375 1.59844 2.4375 3.5625V5.25H1.875C1.25391 5.25 0.75 5.75391 0.75 6.375V10.875C0.75 11.4961 1.25391 12 1.875 12H10.125C10.7461 12 11.25 11.4961 11.25 10.875V6.375C11.25 5.75391 10.7461 5.25 10.125 5.25ZM7.6875 5.25H4.3125V3.5625C4.3125 2.63203 5.06953 1.875 6 1.875C6.93047 1.875 7.6875 2.63203 7.6875 3.5625V5.25Z", fill: "currentColor" })));
